import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {TransitionService} from "@uirouter/angularjs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {Debugger} from "debug";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {gettextCatalog} from "angular-gettext";



require('./gruppeOversikt.scss');
const debug: Debugger = require('debug')('GruppeOversiktKontroller');

export class GruppeOversiktKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wgGruppeOversikt', {
                bindings: {aktivArkfane:'<'},
                controller: GruppeOversiktKontroller.forInjisering(),
                template: require('./gruppeOversikt.html')
            });
    }

    static forInjisering = () => {
        return [
            regNavn.ng.$scope,
            regNavn.ng.ui.$transitions,
            IntroJsTjeneste.regNavn,
            regNavn.gettext.gettextCatalog,
            Kontekst.regNavn,
            WebNavigasjon.regNavn,
            GruppeOversiktKontroller];
    };

    constructor(
        private $scope: IScope,
        private $transitions: TransitionService,
        private introJs: IntroJsTjeneste,
        private gettextCatalog: gettextCatalog,
        private kontekst: Kontekst,
        private webNavigasjon: WebNavigasjon) {
        this.initIntroJs();
    }

    aktivArkfane:'grupper'|'avtaler'|'brukerSikkerhetsinnstillinger'|'brukerMeldingsinnstillinger' = 'grupper';//settes via bindings/lyttTilNavigasjon

    bruker: l.BrukerModell;


    navigerTilGrupper() {
        this.webNavigasjon.gåTilGrupper();
    }

    navigerTilAvtaler() {
        this.webNavigasjon.gåTilAvtaler();
    }

    navigerTilBrukerSikkerhetsinnstillinger() {
        this.webNavigasjon.gåTilBrukerSikkerhetsinnstillinger();
    }

    navigerTilBrukerMeldingsinnstillinger() {
        this.webNavigasjon.gåTilBrukerMeldingsinnstillinger();
    }

    aktivArkfaneGrupper() {
        return this.aktivArkfane === 'grupper';
    }

    aktivArkfaneAvtaler() {
        return this.aktivArkfane === 'avtaler';
    }

    aktivArkfaneBrukerSikkerhetsinnstillinger() {
        return this.aktivArkfane === 'brukerSikkerhetsinnstillinger';
    }

    aktivArkfaneBrukerMeldingsinnstillinger() {
        return this.aktivArkfane === 'brukerMeldingsinnstillinger';
    }

    $onInit(): void {
        this.lastData();
        this.lyttTilBrukerRelastet();
    }


    // privat metoder

    private lastData() {
        this.bruker = this.kontekst.autentisertBruker();
    }

    private lyttTilBrukerRelastet(){
        this.$scope.$on(Kontekst.brukerRelastetEvent, () => this.lastData());
    }

    private initIntroJs() {
        this.introJs.visIntroForsinket(
            this.introJs.nyIntroduksjon('grupper')
                .leggTilSteg(
                    1,
                    {
                        title: this.gettextCatalog.getString('Min profil'),
                        intro: this.gettextCatalog.getString('I profil-menyen kan du redigere e-postadressen din, telefonnummer, navn, bilde og systemspråk.'),
                        element: '[data-tips-id="brukermeny"]',
                        position: "right"
                    }
                )
                .leggTilSteg(
                    2,
                    {
                        title: this.gettextCatalog.getString('Navigasjon'),
                        intro: this.gettextCatalog.getString('Her finner du dine grupper og avtaler, og dine personlige innstillinger for sikkerhet og meldinger.'),
                        element: '[data-tips-id="grupper-navbar"]',
                        position: "bottom"
                    }
                )
                .leggTilSteg(
                    3,
                    {
                        title: this.gettextCatalog.getString('Dine grupper'),
                        intro: this.kontekst.inneharTilgangsrolleINoenGruppe(l.TilgangsrolleMedlem.skrive) ?
                            this.gettextCatalog.getString('Oversikt over dine grupper og gruppeinvitasjoner. Gå inn på en gruppe for å administrere gruppens medlemmer og innstillinger.') :
                            this.gettextCatalog.getString('Oversikt over dine grupper og gruppeinvitasjoner. Gå inn på en gruppe for å se andre medlemmers detaljer.'),
                        element: '[data-tips-id="grupper-dine"]',
                        position: "top"
                    }
                )
                .leggTilSteg(
                    4,
                    {
                        title: this.gettextCatalog.getString('Ny gruppe'),
                        intro: this.gettextCatalog.getString('Begynn å skrive gruppenavnet for å opprette en ny gruppe. Det finnes flere maler, blant annet for ledergrupper, komitéer, generalforsamlinger m.m.'),
                        element: '[data-tips-id="gruppe-ny"]',
                        position: "top"
                    }
                ),
            1000
        );
    }
}
